import { getToken } from './session';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000';

type MethodType = 'GET' | 'POST' | 'PATCH' | 'PUT' | 'DELETE';

export async function apiFetch(
  endpoint: string,
  options: MethodType | (RequestInit & { file?: File }) = 'GET',
  needsAuth = true
): Promise<Response> {
  if (typeof options === 'string') {
    options = { method: options };
  }

  const { file, ...restOptions } = options as RequestInit & { file?: File };
  const headers = new Headers(
    file ? restOptions.headers : { 'Content-Type': 'application/json', ...restOptions.headers }
  );

  let body: BodyInit | undefined = restOptions.body ?? undefined;
  if (file) {
    const form = new FormData();
    form.append('file', file);
    body = form;
  }

  if (needsAuth) {
    const token = getToken();
    if (!token) {
      return new Response(JSON.stringify({ detail: 'Unauthorized' }), { status: 401 });
    }
    headers.set('Authorization', `Bearer ${token}`);
  }

  const url = endpoint.startsWith('http') ? endpoint : new URL(endpoint, API_URL).toString();
  return fetch(url, {
    ...restOptions,
    headers,
    body,
  });
}

export function getApiUrl(): string {
  return API_URL;
}
